import getConfig from "./getConfig";
const config = getConfig();

export default config.payment;
